module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8IUV8"))).then(() => parcelRequire('cvs7o'));